import { Box } from '@mui/material';
import { CurrencyAmount } from '@cowbell/ui/core';
import { useLocale } from '../../../../../quotes/prime-x/providers/LocaleProvider';
import { formatLegacyDeltaPrice } from './legacyDeltaPriceFallback';
import type { Nullable } from '../../../../../../../types/common/utility';

type Props = {
  readonly price: Nullable<number>;
  /** ISO 4217 code for the policy this endorsement belongs to. */
  readonly currency: string | null | undefined;
};

const DeltaPricing = (props: Props) => {
  const locale = useLocale();
  const isNegative = (props?.price ?? 0) < 0;

  return (
    <Box
      component="span"
      sx={{
        color: (theme) => {
          if (props.price === 0) {
            return theme.palette.text.contrastText;
          }
          if (isNegative) {
            return theme.config.colors.paleTomato;
          }

          return theme.config.colors.cowbellAccent;
        },
      }}
    >
      {props.currency != null ? (
        // `currencySign="accounting"` lets CurrencyAmount itself decide whether
        // to wrap a negative value in parentheses.
        <CurrencyAmount
          amount={props.price ?? 0}
          currency={props.currency}
          currencySign="accounting"
          minimumFractionDigits={2}
          maximumFractionDigits={2}
        />
      ) : (
        formatLegacyDeltaPrice(locale.language, props.price, isNegative)
      )}
    </Box>
  );
};

export default DeltaPricing;
